import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonIcon, IonItem, IonRadio, IonRadioGroup } from "@ionic/react"
import { useEffect, useState } from "react";
import { CalculatorStrategyForm } from "./FormTypes";
import { arrowDownOutline, createOutline } from "ionicons/icons";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { canCopy, canFullTrack, canTrocut, mapStrategies } from "./formHelpers";
import { db } from "../../../data/db/db";
import { Material } from "../../../models/materialModel";
import { useTranslation } from "react-i18next";

interface StrategyFormProps {
    isFormShowing: boolean,
    editBtnCallback: () => void,
    submitForm: (data: any) => void,
    ident: string | null | undefined,
    pos: string | undefined
    material: Material | undefined | null,
    formData: CalculatorStrategyForm | undefined
}

const defaultFormValues: CalculatorStrategyForm = {
    strategy: undefined,
}

const StrategyForm: React.FC<StrategyFormProps> = ({ isFormShowing, editBtnCallback, submitForm, ident, pos, material, formData }: StrategyFormProps) => {
    const [data, setData] = useState<CalculatorStrategyForm | null>()
    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<CalculatorStrategyForm>({
        mode: "onTouched",
        reValidateMode: "onChange",
        defaultValues: defaultFormValues
    });
    const [trocutAvailable, setTrocutAvailable] = useState<boolean>(false);
    const [fullTrackAvailable, setFullTrackAvailable] = useState<boolean>(false);
    const [copyAvailable, setCopyAvailable] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (ident && pos && material) {
            (async () => {
                const specFromDB = await db.articlesSpec.where({ ident: ident, pos: pos }).first();

                const trocutAvailableValue = await canTrocut(specFromDB)
                setTrocutAvailable(trocutAvailableValue)

                const fullTrackAvailableValue = await canFullTrack(specFromDB, material.gruppe)
                setFullTrackAvailable(fullTrackAvailableValue);

                const copyAvailableValue = await canCopy(specFromDB);
                setCopyAvailable(copyAvailableValue)

            })();
        }
    }, [ident, pos, material, reset])

    useEffect(() => {
        // console.log(formData)
        if (formData === undefined) {
            reset({ strategy: undefined });
            setData(undefined)
        } else {
            setData(formData);
            setValue("strategy", formData?.strategy ?? undefined)
        }
    }, [formData, reset, setValue])


    const onSubmit: SubmitHandler<CalculatorStrategyForm> = data => {
        setData(data)
        submitForm(data)
    }


    if (isFormShowing) {
        return (
            <>
                <IonCol size="12">
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle>{t("calculatorForm.Bearbeitungs-Strategie")}</IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <form>
                                <Controller
                                    control={control}
                                    name="strategy"
                                    rules={{
                                        required: { value: true, message: t("Feld darf nicht leer sein") },
                                    }}
                                    render={({ field: { value, onChange } }) => (
                                        <IonRadioGroup value={value} onIonChange={({ detail: { value } }) => onChange(value)}>
                                            <IonItem>
                                                <IonRadio value="std-bes" labelPlacement="end" justify="start">
                                                    {t("calculatorForm.StrategyForm.Besäumen")}
                                                </IonRadio>
                                            </IonItem>
                                            <div>{fullTrackAvailable && <IonItem >
                                                <IonRadio value="std-vsp" labelPlacement="end" justify="start">
                                                    {t("calculatorForm.StrategyForm.Vollspur")}
                                                </IonRadio>
                                            </IonItem>}</div>
                                            <div>{copyAvailable && <IonItem>
                                                <IonRadio value="std-ko" labelPlacement="end" justify="start">
                                                    {t("calculatorForm.StrategyForm.Kopieren")}
                                                </IonRadio>
                                            </IonItem>}</div>
                                            <div>{trocutAvailable && <IonItem>
                                                <IonRadio value="tro" labelPlacement="end" justify="start">
                                                    {t("calculatorForm.StrategyForm.Trocut")}
                                                </IonRadio>
                                            </IonItem>}</div>
                                        </IonRadioGroup>
                                    )}
                                />
                                {/* @ts-ignore */}
                                {errors.strategy && <div className="error" style={{ marginLeft: 16 }}>{errors.strategy.message}</div>}
                                <IonButton style={{ marginTop: 24 }} onClick={handleSubmit(onSubmit)} expand="block">
                                    <IonIcon slot="start" icon={arrowDownOutline} />{t("calculatorForm.Parameter")}
                                </IonButton>
                            </form>
                        </IonCardContent>
                    </IonCard>
                </IonCol>
            </>
        )
    } else {
        if (data) {
            return (
                <IonCol size="12">
                    <IonCard color="light" className="millerFormCompletedCard">
                        <IonCardContent>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                <div>
                                    <div><b>{t("calculatorForm.Bearbeitungs-Strategie")}:</b>{" "} {data.strategy && mapStrategies(data.strategy)}</div>
                                </div>
                                <div>
                                    <IonButton fill="outline" onClick={editBtnCallback}>
                                        <IonIcon icon={createOutline} slot="icon-only" />
                                    </IonButton>
                                </div>
                            </div>
                        </IonCardContent>
                    </IonCard>
                </IonCol>
            )
        }
        return null;
    }

}

export default StrategyForm;